import { css } from 'styled-components'

export default {
  outlined: css`
    border-width: ${({ theme }) => theme.border.width.thinner};
    border-style: ${({ theme }) => theme.border.style.solid};
  `,
  filled: css`
    background: ${({ theme }) => theme.color.background.neutral.strong};
  `,
}
